"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Metric = void 0;
var Metric;
(function (Metric) {
    Metric["AudienceCity"] = "audience_city";
    Metric["AudienceCountry"] = "audience_country";
    Metric["AudienceGenderAge"] = "audience_gender_age";
    Metric["Reach"] = "reach";
    Metric["Impressions"] = "impressions";
    Metric["Saved"] = "saved";
})(Metric = exports.Metric || (exports.Metric = {}));
//# sourceMappingURL=metrics.enum.js.map